export default {"src":"/_next/static/media/beets.b39dd9bb.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};